import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

const CustomArrowUpward = ({ sx, ...props }) => (
  <ArrowUpwardIcon sx={{ color: 'gray', fontSize: '15px', ...sx }} {...props} />
);

const CustomArrowDownward = ({ sx, ...props }) => (
  <ArrowDownwardIcon sx={{ color: 'gray', fontSize: '15px', ...sx }} {...props} />
);

const CustomOrderArrow = ({ direction, sx, ...props }) => (
    direction === 'asc' 
        ? <CustomArrowUpward sx={sx} {...props} /> 
        : <CustomArrowDownward sx={sx} {...props} />
);
  

export { CustomArrowUpward, CustomArrowDownward };
export default CustomOrderArrow;